// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const roofTileStack = defineModel({
  id: "roof-tile-stack",
  batchId: "future",
  name: "Roof-tile stack",
  tags: ["scenery","roof","tile","stack","low-poly","age-of-mcp","future"],
  summary: "Stacks of terracotta tiles — weatherproof roofing for many buildings.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.4,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.24, 0.018, 0.16), color: "#bb5a3a", position: [-0.11, 0.07, 0.06], rotation: [0, 0, 0.4] },
      { geometry: new THREE.BoxGeometry(0.24, 0.018, 0.16), color: "#a84e32", position: [-0.086, 0.1, 0.06], rotation: [0, 0, 0.4] },
      { geometry: new THREE.BoxGeometry(0.24, 0.018, 0.16), color: "#bb5a3a", position: [-0.062, 0.13, 0.06], rotation: [0, 0, 0.4] },
      { geometry: new THREE.BoxGeometry(0.24, 0.018, 0.16), color: "#a84e32", position: [-0.038, 0.16, 0.06], rotation: [0, 0, 0.4] },
      { geometry: new THREE.BoxGeometry(0.24, 0.018, 0.16), color: "#bb5a3a", position: [-0.014, 0.19, 0.06], rotation: [0, 0, 0.4] },
      { geometry: new THREE.BoxGeometry(0.24, 0.018, 0.16), color: "#a84e32", position: [0.01, 0.22, 0.06], rotation: [0, 0, 0.4] },
      { geometry: new THREE.BoxGeometry(0.24, 0.018, 0.16), color: "#bb5a3a", position: [0.11, 0.07, -0.06], rotation: [0, 0, -0.4] },
      { geometry: new THREE.BoxGeometry(0.24, 0.018, 0.16), color: "#a84e32", position: [0.134, 0.1, -0.06], rotation: [0, 0, -0.4] },
      { geometry: new THREE.BoxGeometry(0.24, 0.018, 0.16), color: "#bb5a3a", position: [0.158, 0.13, -0.06], rotation: [0, 0, -0.4] },
      { geometry: new THREE.BoxGeometry(0.24, 0.018, 0.16), color: "#a84e32", position: [0.182, 0.16, -0.06], rotation: [0, 0, -0.4] },
      { geometry: new THREE.BoxGeometry(0.24, 0.018, 0.16), color: "#bb5a3a", position: [0.206, 0.19, -0.06], rotation: [0, 0, -0.4] },
      { geometry: new THREE.BoxGeometry(0.24, 0.018, 0.16), color: "#a84e32", position: [0.23, 0.22, -0.06], rotation: [0, 0, -0.4] },
    ],
  animations: [],
});
